"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.configIcon = void 0;
var configIcon = exports.configIcon = {
  large: {
    height: "var(--spacing-global-space8)",
    // 40px;
    width: "var(--spacing-global-space8)"
  },
  medium: {
    height: "var(--spacing-global-space7)",
    // 32px;
    width: "var(--spacing-global-space7)"
  },
  small: {
    height: "var(--spacing-global-space6)",
    // 24px;
    width: "var(--spacing-global-space6)"
  },
  xsmall: {
    height: "var(--spacing-global-space5)",
    // 16px;
    width: "var(--spacing-global-space5)"
  }
};
var _default = exports["default"] = configIcon;